import { createContext, useContext, useState } from "react";
import Toast from "../components/ToastMessage/Toast";

// Corrected the name to ToastProvider
export const ToastContext = createContext({});

export const ToastProvider = ({ children }) => {
  const [showToast, setShowToast] = useState({
    isshown: false,
    message: "",
    type: "add",
  });

  const handleCloseToast = () => {
    setShowToast({ isshown: false, message: "" });
  };

  const showToastMessage = (message, type) => {
    setShowToast({ isshown: true, message, type });
    const timeoutId = setTimeout(() => {
      handleCloseToast();
    }, 4000);

    return () => {
      clearTimeout(timeoutId);
    };
  };

  return (
    <ToastContext.Provider value={{ showToastMessage }}>
      <Toast
        isShown={showToast.isshown}
        message={showToast.message}
        type={showToast.type}
      />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  return context;
};
